module.exports = __webpack_public_path__ + "img/خلاق.efa8d56a.jpg";